import axios from 'axios'

export default {
  search: function (applicantId) {
    return axios.get('/api/vacancy/getApplicantServiceList?id=' + applicantId)
  },
  find: function (id) {
    return axios.get('/api/vacancy/findApplicantService?id=' + id)
  },
  save: function (data) {
    return axios.post('/api/vacancy/saveApplicantService', data)
  },  
  delete: function (id) {
    return axios.delete('/api/vacancy/deleteApplicantService?id='+id)
  },  
}